import React from 'react';
import PropTypes from 'prop-types';
import { useDividerGradient } from '../gradient-utils';

export function Arrow({
  className,
  depth = 50,
  position = 50,
  fadeOpacity,
  fadeDirection,
  softness,
  style
}) {
  const { defs, fill, mask } = useDividerGradient({ fadeOpacity, fadeDirection, softness });

  // depth 0 = flat, depth 100 = arrow point at bottom (y=120)
  const pointY = (depth / 100) * 120;
  // position 0 = left, 50 = center, 100 = right
  const pointX = 200 + (position / 100) * 800;

  return (
    <svg
      className={ className }
      style={ style }
      viewBox='0 0 1200 120'
      preserveAspectRatio='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      { defs }
      <polygon points={ `0,0 ${pointX},${pointY} 1200,0 1200,120 0,120` } fill={ fill } mask={ mask } />
    </svg>
  );
}

Arrow.propTypes = {
  className: PropTypes.string,
  depth: PropTypes.number,
  position: PropTypes.number,
  fadeOpacity: PropTypes.number,
  fadeDirection: PropTypes.oneOf(['down', 'up', 'left', 'right']),
  softness: PropTypes.number
};
